import React, { Dispatch, SetStateAction } from 'react'
import './styles.scss'

interface Props {
  closemodal: Dispatch<SetStateAction<MarkedInterface | undefined>>

  children: JSX.Element | string
  locale: string
}

export const Modal = ({ closemodal, children, locale }: Props) => (
  <div className='Modal'>
    <div className='inner'>
      <>
        {children && children} <Close onclick={closemodal} locale={locale} />
      </>
    </div>
  </div>
)

const Close = ({
  onclick,
  locale
}: {
  onclick: Dispatch<SetStateAction<MarkedInterface | undefined>>
  locale: string
}) => (
  <div className='closewrapper'>
    <button
      className='close'
      onClick={() => {
        onclick(undefined)
      }}
    >
      {locale}
    </button>
  </div>
)
